export function speak(text: string) {
    if (!document.body.classList.contains('bvi-active')) return;
    if (text.trim().length === 0) return;

    if ('speechSynthesis' in window) {
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = 'ru-RU';
        window.speechSynthesis.speak(utterance);
    }
}
